import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { InfoMessages } from 'apps/driver-dashboardfe/src/app/shared/constants/info-messages.constant';

@Component({
    standalone: false,
    selector: 'octo-rideshare-dialog',
    templateUrl: './rideshare-dialog.component.html',
    styleUrls: ['./rideshare-dialog.component.scss'],
})
export class RideshareDialogComponent {
    constructor(
        private modalRef: MatDialogRef<RideshareDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data: any
    ) {}

    close(): void {
        this.modalRef.close({});
    }
}
